import React, { createContext, useMemo } from 'react'
import { AuthorSegment, NewsBanner } from './fragments'
import { StyledGreyBackground, StyledNewsWrapper } from './styledNewsDetail'
import { Contained } from '../../components/contained/contained'
import { nonNull } from '../../utils/nonNull'
import { CarouselArrayType } from '../../pages/community/news/[slug]'
import { LazyComponent } from '../../components/lazyComponent/lazyComponent'
import dynamic from 'next/dynamic'
import { NewsDetailQuery } from '@gql'

export type NewsDetailProps = NewsDetailQuery & { carousel: CarouselArrayType}

export const NewsPageContext = createContext<{newsPageId:string}>({
  newsPageId:'',
})

const TopContent = dynamic(() => import('./fragments/topContent').then(mod => mod.TopContent))
const BelowTheFold = dynamic(() => import('./fragments/belowTheFold').then(mod => mod.BelowTheFold))

export const NewsDetail: React.VFC<NewsDetailProps> = (props) => {
  const { entry } = props

  if (!entry || entry.__typename !== 'news_newsEntryType_Entry' || entry.status !== 'live') {
    return null
  }

  const { id, postDate, newsCategory, newsAuthor } = entry

  const newsPageId = useMemo(() => {
    return id as string
  }, [id])

  return (
    <NewsPageContext.Provider value={{ newsPageId }}>
      <StyledNewsWrapper>
        <NewsBanner { ...entry } />
        <StyledGreyBackground>
          <Contained container>
            {/** @ts-ignore */}
            <AuthorSegment authorData={newsAuthor} categoryData={newsCategory} dateUpdated={postDate} />
          </Contained>
          <LazyComponent>
            <TopContent { ...props } />
          </LazyComponent>
        </StyledGreyBackground>
        <LazyComponent>
          <BelowTheFold { ...props } />
        </LazyComponent>
      </StyledNewsWrapper>
    </NewsPageContext.Provider>
  )
}
